export default __webpack_public_path__ + "static/media/019-rhythmic gymnastics.9926605f.svg";